module.exports = __webpack_public_path__ + "img/6117252.png";